// extracted by css-extract-rspack-plugin
export default {"chartLoader":"chartLoader-B6TDzo","cappedToViewport":"cappedToViewport-bIFa6w"};